<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="page_x"></a><a id="page_xi"></a>•  CONTENTS  •</h2>
<p class="indentnumber"><a class="nounder" href="#/xhtml/frontmatter001">Introduction</a></p>
<p class="indentnumber"><a class="nounder" href="#/xhtml/chapter001"><em>One</em>: Pandora’s Box</a></p>
<p class="indentnumber"><a class="nounder" href="#/xhtml/chapter002"><em>Two</em>: Stripped</a></p>
<p class="indentnumber"><a class="nounder" href="#/xhtml/chapter003"><em>Three</em>: Corseted</a></p>
<p class="indentnumber"><span class="nounder" href="#/xhtml/chapter004" title="Link target outside of Sample"><em>Four</em>: Ride Like a Man</span></p>
<p class="indentnumber"><span class="nounder" href="#/xhtml/chapter005" title="Link target outside of Sample"><em>Five</em>: The Pouf Ascendant</span></p>
<p class="indentnumber"><span class="nounder" href="#/xhtml/chapter006" title="Link target outside of Sample"><em>Six</em>: The Simple Life</span></p>
<p class="indentnumber"><span class="nounder" href="#/xhtml/chapter007" title="Link target outside of Sample"><em>Seven</em>: Galled</span></p>
<p class="indentnumber"><span class="nounder" href="#/xhtml/chapter008" title="Link target outside of Sample"><em>Eight</em>: Revolutionary Redress</span></p>
<p class="indentnumber"><span class="nounder" href="#/xhtml/chapter009" title="Link target outside of Sample"><em>Nine</em>: True Colors</span></p>
<p class="indentnumber"><span class="nounder" href="#/xhtml/chapter010" title="Link target outside of Sample"><em>Ten</em>: Black</span></p>
<p class="indentnumber"><span class="nounder" href="#/xhtml/chapter011" title="Link target outside of Sample"><em>Eleven</em>: White</span></p>
<p class="indentnumber"><span class="nounder" href="#/xhtml/backmatter001" title="Link target outside of Sample">Afterword: Fashion Victim</span></p>
<p class="indentnumber"><span class="nounder" href="#/xhtml/backmatter002" title="Link target outside of Sample">Notes</span></p>
<p class="indentnumber"><span class="nounder" href="#/xhtml/backmatter003" title="Link target outside of Sample">Selected Bibliography</span></p>
<p class="indentnumber"><span class="nounder" href="#/xhtml/backmatter004" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="indentnumber"><span class="nounder" href="#/xhtml/backmatter005" title="Link target outside of Sample">Illustration Acknowledgments</span></p>
<p class="indentnumber"><span class="nounder" href="#/xhtml/backmatter006" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?4bb6ad62